var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","color":_vm.tag.color,"dark":!_vm.darkMode}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_vm._v(" "+_vm._s(_vm.tag.shortName)+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }